// src/pages/ServicePage.jsx

import { ArrowLeft, Building2, MapPin } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";

import bgImage from "../assets/images/1768687732162_3D.png"; // عدّل المسار إذا لزم

const municipalities = [
  { name: "Aïn Abid", slug: "ain_abid" },
  { name: "Zighoud Youcef", slug: "zighoud_youssef" },
  { name: "Ibn Ziad", slug: "ibn_ziad" },
  { name: "Hamma Bouziane", slug: "hamma_bouziane" },
  { name: "El Khroub", slug: "el_khroub" },
  { name: "Constantine", slug: "constantine" },
];

const serviceNames = {
  lawyer: "محامون",
  translator: "مترجمون",
  notary: "موثقون",
  judicial_expert: "خبراء قضائيون",
};

export default function ServicePage() {
  const { serviceName } = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Header */}
      <div className="bg-white/90 backdrop-blur-md border-b border-gray-200 px-6 py-4 flex items-center gap-4">
        <button
          onClick={() => navigate("/dashboard-Client")}
          className="flex items-center gap-2 text-sm text-green-700 hover:text-green-800"
        >
          <ArrowLeft size={18} />
          رجوع
        </button>

        <h1 className="text-lg font-semibold text-gray-800">
          {serviceNames[serviceName]}
        </h1>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-6 py-10">
        <h2 className="text-center text-3xl font-bold text-white mb-10 drop-shadow-lg">
          اختر البلدية
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {municipalities.map((m) => (
            <div
              key={m.slug}
              onClick={() => navigate(`/municipality/${serviceName}/${m.slug}`)}
              className="
                cursor-pointer
                bg-white/90
                backdrop-blur-md
                border
                border-gray-200
                rounded-xl
                p-5
                hover:-translate-y-1
                hover:border-green-600
                hover:shadow-xl
                transition-all
                duration-300
              "
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-green-100 flex items-center justify-center">
                  <Building2 className="text-green-600" size={22} />
                </div>

                <div>
                  <h3 className="font-semibold text-gray-800">{m.name}</h3>

                  <p className="text-sm text-gray-500 flex items-center gap-1 mt-1">
                    <MapPin size={14} />
                    عرض المختصين
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 flex justify-center">
          <div className="bg-white/80 backdrop-blur-md rounded-xl px-6 py-4 flex flex-wrap justify-center gap-6 text-sm text-gray-700 shadow-lg">
            <span>✔ خدمة موثوقة</span>
            <span>✔ حجز منظم</span>
            <span>✔ مختصون معتمدون</span>
          </div>
        </div>
      </div>
    </div>
  );
}
